import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white" data-id="element-47" data-mp="1lcafxcu66n62">
      <div className="mx-auto max-w-3xl px-5 py-16 lg:py-20" data-id="element-48" data-mp="1gcxqckbwz1zs">
        <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-49" data-mp="1geilab254my6">
          Antes de que preguntes
        </h2>

        <div className="mt-8 divide-y divide-ink/10 border-t border-ink/10" data-id="element-50" data-mp="291mms620yj57">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-51" data-mp="24438551f04cq" data-mpi={i}>
                <h3 data-id="element-52" data-mp="1z3ozplvwise6">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left font-sans text-lg font-bold text-ink transition-colors duration-150 ease-soft hover:text-tomato focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-tomato" data-id="element-53" data-mp="1z2dstd75t4iu">
                    {faq.q}
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-tomato transition-transform duration-200 ease-soft ${isOpen ? 'rotate-45' : ''}`} data-id="element-54" data-mp="fj8hvmt4o9bj" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="bk9dc3bb6ekm">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-56" data-mp="3t0hldz9761dm">
                      <p className="pb-6 pr-8 font-sans text-base leading-relaxed text-muted" data-id="element-57" data-mp="1uh4c9itl6gvq">
                        {faq.a}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}